export const STAGING = 'staging';
export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const LOCAL = 'local';
